<app-card-content [border]="false" [headerColor]="true" icon="pi pi-graduation-cap" title="Formações" subtitle="Lista de formações acadêmicas">
    <div card-header>
        <app-botao-acoes [label]="'Ações'" [items]="acoesNovo()" [appCan]="roleFormacaoCriar" [appCanUf]="pessoa()?.uf" />
    </div>
    <app-custom-table [metadata]="metadataTabela" [data]="dataTabela()" [loading]="loading()" [initialViewMode]="'table'" [showExpandButton]="false" [permissaoUf]="pessoa()?.uf ?? null" />
</app-card-content>
